export const translations = {
  en: {
    lang: 'en',
    a11y: {
      openMenu: "Open menu",
      closeMenu: "Close menu",
      scrollDown: "Scroll to next section",
      linkedin: "MailAmericas on LinkedIn"
    },
    nav: {
      process: "Process",
      prealert: "Pre-Alert",
      dangerousGoods: "DG",
      warehouses: "Warehouses",
      destinations: "Destinations",
      fulfillment: "Fulfillment",
      returns: "Returns",
      contact: "Contact",
      shipWithUs: "Ship with us",
      accountSetup: "Account Setup",
      apiDocs: "API Docs"
    },
    fulfillment: {
      integrated: "Integrated",
      badge: "Fulfillment Center",
      title: "Fulfillment Miami",
      subtitle: "Your strategic hub to conquer the American market. Store, pick, pack and ship from the heart of the Americas with direct connections to all major marketplaces.",
      operations: "Operations",
      connectedTo: "Connected to all major marketplaces",
      moreMarketplaces: "And many more platforms",
      customIntegration: "We can also integrate your e-commerce with a custom solution.",
      marketplaces: {
        badge: "Marketplace Integrations",
        title: "Plug into",
        titleAccent: "every channel that matters",
        subtitle: "From the biggest marketplaces in the Americas to your own custom storefront — your inventory, one fulfillment center."
      },
      ctaBadge: "Free consultation",
      ctaTitle: "Ready to scale your e-commerce?",
      ctaDesc: "Let us handle your logistics while you focus on growing your business. Get a personalized quote for your fulfillment needs.",
      ctaButton: "Request a Quote",
      ctaSubtext: "Response within 24 business hours"
    },
    destinations: {
      badge: "Delivery Network",
      title: "Where We Deliver",
      subtitle: "From Miami to the world. Your packages reach 89 countries across 3 continents with reliable last-mile delivery.",
      subtitle2: "Last-mile delivery worldwide",
      countries: "countries",
      continents: "Continents",
      countriesLabel: "countries",
      including: "Including",
      more: "more destinations",
      note: "Coverage expanding continuously",
      contactUs: "Ask about a specific destination"
    },
    accountSetup: {
      pageTitle: "Client Account Setup",
      subtitle: "Complete your company profile to start shipping with MailAmericas",
      instruction: "Please fill in English",
      backToHome: "Back to Home",
      sections: {
        clientInfo: "Client Information",
        bankInfo: "Bank Information",
        contacts: "Contacts",
        shippingAddresses: "Shipping Addresses"
      },
      clientInfo: {
        customerName: "Customer Name",
        companyName: "Company Name (Legal Name)",
        taxId: "Tax ID",
        address: "Address",
        district: "District",
        city: "City",
        state: "State",
        phoneNumber: "Phone Number",
        zipCode: "Zip Code",
        webpage: "Webpage"
      },
      bankInfo: {
        title: "Primary Bank",
        beneficiaryName: "Beneficiary Name",
        bankName: "Bank Name",
        accountNumber: "Account Number",
        bankAddress: "Bank Address",
        country: "Country",
        currency: "Currency",
        swiftCode: "SWIFT Code",
        abaCode: "ABA Code",
        correspondentBank: "Correspondent Bank",
        correspondentTitle: "Correspondent Bank (if applicable)",
        payoneerOption: "Payoneer Option",
        payoneerAccount: "Payoneer Account Email",
        currencyPreference: "Currency Preference"
      },
      contacts: {
        commercial: "Commercial Contact",
        operations: "Operations Contact",
        financial: "Financial Contact",
        contactName: "Contact Name",
        position: "Position",
        phone: "Phone",
        cellPhone: "Cell Phone",
        email: "E-mail",
        wechat: "WeChat",
        skype: "Skype"
      },
      shipping: {
        warehouseTitle: "Shipping Address",
        warehouseLegalName: "Warehouse Legal Business Name",
        warehouseManager: "Warehouse Manager Name",
        warehousePhone: "Warehouse Phone",
        shippingAddress: "Shipping Address",
        city: "City",
        zipCode: "Zip Code",
        state: "State",
        country: "Country",
        addAddress: "Add Another Address",
        removeAddress: "Remove"
      },
      form: {
        submit: "Submit Application",
        submitting: "Submitting...",
        success: "Your application has been submitted successfully! Our team will contact you shortly.",
        error: "There was an error submitting your application. Please try again.",
        validation: "Please complete the fields marked with * and correct the ones highlighted in red.",
        required: "Required field",
        previous: "Previous",
        next: "Next",
        selectPlaceholder: "Select...",
        errors: {
          tooLong: "Too long: maximum {max} characters",
          text: "Contains invalid characters, or < > which are not allowed",
          phone: "Enter a valid phone number: digits and + - ( ) only",
          taxId: "Enter a valid tax ID: letters, numbers and - . / only, with at least one number",
          zip: "Enter a valid zip code: letters, numbers and - . / only",
          code: "Only letters, numbers, spaces and - . / are allowed",
          email: "Enter a valid e-mail address, e.g. name@company.com",
          url: "Enter a valid web address, e.g. https://www.company.com",
          invalid: "Invalid value"
        }
      }
    },
    hero: {
      title: "GLOBAL SHIPPING",
      titleAccent: "SIMPLIFIED.",
      subtitle: "The most reliable logistics partner for e-commerce sellers worldwide.",
      cta: "Start Shipping Now",
      ctaSecondary: "View Warehouses",
      stats: {
        originWarehouses: "Origin Warehouses",
        continents: "Continents",
        operations: "Operations",
        certified: "Certified"
      }
    },
    process: {
      label: "Step by Step",
      title: "CARGO DROP-OFF",
      titleAccent: "MADE SIMPLE",
      apiAvailable: "Also via API",
      clickHere: "Click here",
      step: "STEP",
      downloadTemplate: "Download BOL template",
      usOps: {
        label: "US Warehouses",
        cta: "Address, hours & details",
        title: "How each US warehouse receives cargo",
        subtitle: "Receiving rules differ by warehouse. Check the one you ship to before planning the drop-off.",
        cols: {
          warehouse: "Warehouse",
          delivery: "Delivery method",
          bol: "Bill of Lading (TSA)",
          dg: "Dangerous Goods",
          notes: "Scope"
        },
        delivery: {
          both: "Own logistics or commercial carrier",
          carrierOnly: "Commercial carrier only"
        },
        bol: {
          own: "Required for own-logistics drop-offs",
          carrier: "Not required: carrier documents apply"
        },
        dg: {
          yes: "Authorized",
          no: "Not accepted"
        },
        notes: {
          miami: "All destinations. Only DG-authorized US warehouse",
          laredo: "Cargo destined to Mexico only",
          carrier: "All destinations. Personal deliveries refused at the gate"
        }
      },
      steps: {
        tsa: {
          title: "TSA Registration",
          subtitle: "Only for US Origin Cargo",
          description: "Register in our TSA Form to ensure your cargo is authorized to travel by air through the United States."
        },
        labels: {
          title: "Generate Labels",
          subtitle: "API or Platform",
          description: "Generate the shipping label through our API or directly via the e-commerce platform where you sell your products."
        },
        prealert: {
          title: "Pre-Alert",
          subtitle: "24h Before Drop-off",
          description: "Pre-alert your cargo to our warehouse at least 24 hours before your drop-off."
        },
        delivery: {
          title: "Cargo Delivery",
          subtitle: "Deliver to Warehouse",
          description: "Deliver the cargo during operating hours, following the receiving rules of your warehouse. See the US warehouse table below."
        },
        confirmation: {
          title: "Gate-In Confirmation",
          subtitle: "Within 24 Business Hours",
          description: "Receive the gate-in confirmation within 24 business hours from the drop-off."
        }
      }
    },
    dangerousGoods: {
      label: "Important Notice",
      title: "DANGEROUS GOODS",
      titleAccent: "PROTOCOLS",
      miamiOnly: {
        badge: "Authorized US Facility",
        title: "Miami is our only DG-authorized warehouse in the United States.",
        description: "All Dangerous Goods (DG) shipments handled through our US network must be routed exclusively to our Miami facility. Our other US warehouses — LAX, ORD and EWR — are not certified to receive, process or dispatch DG cargo.",
        locationLabel: "DG Authorized US Site"
      },
      intro: "MailAmericas allows receiving Lithium-Ion Batteries under UN 3481 PI 967 and PI 966 Section II, and Metal Batteries under UN 3091 PI 970 and PI 969 Section II.",
      warning: "Important: Some e-commerce products are classified as Dangerous Goods (DG) under international air transport regulations (IATA). Please review your items carefully before shipping.",
      productsTitle: "Products commonly considered DG:",
      products: [
        "Lithium batteries (loose, built-in, or with equipment)",
        "Perfumes, sprays, and cosmetics containing alcohol",
        "Aerosols (deodorants, cleaning sprays, etc.)",
        "Chemicals, powders, flammable or pressurized liquids"
      ],
      howToDeclare: "How to Declare Dangerous Goods?",
      declareOptions: [
        "Labeling: Identify the boxes containing DG items by applying the appropriate DG sticker.",
        "Pre-alert Manifest: Indicate in the pre-alert which specific boxes contain the DG cargo."
      ],
      note: "MailAmericas will issue the DG Certificate after inspecting the shipment at our warehouse."
    },
    warehouses: {
      label: "Global Network",
      title: "OUR",
      titleAccent: "WAREHOUSES",
      subtitle: "Strategic fulfillment centers across 5 continents.",
      regions: {
        usa: "United States",
        asia: "Asia",
        europe: "Europe",
        africa: "Africa",
        southamerica: "South America"
      }
    },
    network: {
      locations: "Locations",
      dgAuthorized: "DG AUTHORIZED",
      origins: "Warehouses",
      destinations: "Destinations",
      originsLabel: "Origin Warehouses",
      destinationsLabel: "Delivery Network",
      originsTitle: "WHERE WE",
      originsHighlight: "COLLECT",
      destinationsTitle: "WHERE WE",
      destinationsHighlight: "DELIVER",
      originsSubtitle: "Strategic injection points across 5 continents — your inventory starts here.",
      destinationsSubtitle: "89 countries reached worldwide from our Miami hub with reliable last-mile delivery.",
      countries: "Countries",
      continents: "Continents",
      moreCountries: "and many more",
      fromMiami: "From Miami Hub:",
      deliveryNote: "Direct connection to 89 destination countries with optimized transit times.",
      sopBadge: "Carrier Drop-Off SOP",
      sopTitle: "Universal Rules",
      sopSubtitle: "What every driver must do, every time — applies to all our USA warehouses.",
      sopRules: [
        { t: "Bring the right delivery documents", d: "Commercial carriers: the carrier's own Bill of Lading or delivery receipt, with the tracking or PRO number. Own logistics (Miami, and Laredo for Mexico-bound cargo): a completed TSA Bill of Lading, with a TSA Known Shipper FROM address on file. One BOL per delivery day.", download: true },
        { t: "Present a valid government-issued ID", d: "No exceptions. Packages will not be received without ID verification." },
        { t: "Ramp for vans · Dock for trucks", d: "Do not begin unloading until our team confirms the dock assignment." },
        { t: "Unload only at the assigned dock", d: "Not in the parking lot, ramp, lobby or any other area. Receipts and inbound scans are tied to the dock drop." }
      ],
      sopDocLabel: "Download BOL template for own logistics (PDF)",
      sopContactLabel: "Receiving coordination:",
      securityNotice: {
        badge: "Security Notice",
        title: "Commercial carrier delivery required at ORD, EWR and LAX",
        body: "For security reasons and in line with air cargo security requirements, our Chicago (ORD), New Jersey (EWR) and Los Angeles (LAX) warehouses receive cargo exclusively through commercial carriers. Personal deliveries, including cargo brought in by sellers, their staff or any private vehicle, cannot be received at these locations.",
        howTo: "To deliver cargo to these warehouses, ship it through an established U.S. carrier. Pre-alert the shipment at least 24 hours in advance and include the carrier tracking or PRO number.",
        parcelLabel: "Parcel carriers",
        freightLabel: "LTL & freight carriers",
        carriersNote: "The carriers listed above are recommendations only. You may use any other commercial carrier of your choice, as long as it is a licensed commercial carrier, the shipment is pre-alerted at least 24 hours in advance and it arrives with a carrier tracking or PRO number.",
        footnote: "Personal deliveries arriving at ORD, EWR or LAX will be refused at the gate. Receiving procedures at Miami and Laredo remain unchanged.",
        tag: "CARRIER ONLY"
      },
      regions: {
        usa: "United States",
        asia: "Asia",
        europe: "Europe",
        africa: "Africa",
        southamerica: "South America",
        america: "Americas"
      }
    },
    apiDocs: {
      badge: "Developer Resources",
      title: "API",
      titleAccent: "DOCUMENTATION",
      subtitle: "Integrate MailAmericas into your stack. Send Pre-Alerts and generate shipping labels via API — or use our web forms. Your choice.",
      copy: "Copy",
      copied: "Copied!",
      prealert: {
        tab: "Pre-Alerts API",
        heading: "Pre-Alert Submission API",
        description: "Submit shipment pre-alerts programmatically. Send your dispatch data, ETA, warehouse and tracking numbers in a single POST request. Pre-alerts are also available via the standard web form — use whichever fits your workflow.",
        salesNoteLabel: "Credentials",
        salesNote: "The production endpoint and your unique API Key will be provided by your MailAmericas Sales team upon onboarding.",
        requestBody: "Request Body",
        exampleTitle: "request.example.json"
      },
      label: {
        tab: "Label Generator API",
        tab2: "Label Generator",
        heading: "Parcel Label Generation API v1.0",
        description: "Generate shipping labels for your packages programmatically. Supports PDF and ZPL formats with full international compliance — Brazil, Mexico, Chile, Egypt and more.",
        method: "Method",
        formats: "Formats",
        envs: "Environments",
        salesNote: "Test and Production URLs, plus authentication details, are provided by your MailAmericas Sales team.",
        tabs: {
          general: "General",
          package: "Package",
          shipper: "Shipper",
          buyer: "Buyer",
          items: "Items",
          cod: "COD"
        },
        annex: {
          brazil: {
            title: "Brazil — Special Validations",
            items: [
              { k: "Packet Standard", v: "max 30kg, length 15-100cm, width 10-100cm, height 2-100cm." },
              { k: "Packet Express", v: "max 30kg, length 15-100cm, width 10-100cm, height 1-100cm." },
              { k: "Packet Mini", v: "max 300g, length 16-24cm, width 11-16cm, height 1-4cm." },
              { k: "Buyer ID", v: "CPF (11 chars) or CNPJ (14 chars), else taken as passport." }
            ]
          },
          others: {
            title: "Egypt, COAR, MX & CL — Extras",
            items: [
              { k: "Egypt", v: "DDP packages require valid `hs_code` or category." },
              { k: "COAR", v: "Buyer postal code must contain 4-8 chars." },
              { k: "MX & CL", v: "Response includes `returns_address`, `sorting_last_mile`, `sorting_warehouse`, `buyer_zip_code`." }
            ]
          }
        },
        businessLogic: {
          title: "Business Logic — Value & Weight",
          description: "The system always uses the highest of two values when generating labels:",
          value: "Value",
          valueDesc: "Compares declared package value vs sum of all items value — takes the greater.",
          weight: "Weight",
          weightDesc: "Compares declared package weight vs sum of all items weight — takes the greater."
        }
      },
      table: {
        field: "Field",
        type: "Type",
        required: "Required",
        requiredYes: "Yes",
        requiredNo: "No",
        description: "Description"
      },
      response: {
        success: "Success",
        successNote: "Pre-alert accepted and processed.",
        error: "Error",
        errorNote: "Invalid payload — check required fields."
      },
      cta: {
        title: "Ready to Integrate?",
        description: "Get your API credentials and start automating pre-alerts and label generation today. Our Sales team is ready to onboard you.",
        button: "Contact our Sales team"
      }
    },
    notFound: {
      title: "Page not found",
      description: "The page you are looking for does not exist or has been moved.",
      cta: "Back to Home"
    },
    footer: {
      tagline: "Your trusted logistics partner for global e-commerce.",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      contact: "Contact",
      rights: "All rights reserved."
    }
  },
  es: {
    lang: 'es',
    a11y: {
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
      scrollDown: "Ir a la siguiente sección",
      linkedin: "MailAmericas en LinkedIn"
    },
    nav: {
      process: "Proceso",
      prealert: "Pre-Alerta",
      dangerousGoods: "DG",
      warehouses: "Almacenes",
      destinations: "Destinos",
      fulfillment: "Fulfillment",
      returns: "Devoluciones",
      contact: "Contacto",
      shipWithUs: "Envía con nosotros",
      accountSetup: "Registro",
      apiDocs: "API Docs"
    },
    fulfillment: {
      integrated: "Integrado",
      badge: "Centro de Fulfillment",
      title: "Fulfillment Miami",
      subtitle: "Tu hub estratégico para conquistar el mercado americano. Almacena, prepara y envía desde el corazón de las Américas con conexión directa a todos los marketplaces.",
      operations: "Operaciones",
      connectedTo: "Conectado a todos los marketplaces",
      moreMarketplaces: "Y muchas plataformas más",
      customIntegration: "También podemos integrar tu e-commerce en forma personalizada.",
      marketplaces: {
        badge: "Integraciones de Marketplace",
        title: "Conéctate a",
        titleAccent: "todos los canales que importan",
        subtitle: "Desde los marketplaces más grandes de las Américas hasta tu propio storefront custom — un solo inventario, un solo fulfillment center."
      },
      ctaBadge: "Consulta gratuita",
      ctaTitle: "¿Listo para escalar tu e-commerce?",
      ctaDesc: "Déjanos tu logística mientras te enfocas en hacer crecer tu negocio. Recibe una cotización personalizada para tus necesidades de fulfillment.",
      ctaButton: "Solicitar cotización",
      ctaSubtext: "Respuesta en menos de 24 horas hábiles"
    },
    destinations: {
      badge: "Red de Entregas",
      title: "Dónde Entregamos",
      subtitle: "Desde Miami al mundo. Tus paquetes llegan a 89 países en 3 continentes con entrega de última milla confiable.",
      subtitle2: "Entrega de última milla mundial",
      countries: "países",
      continents: "Continentes",
      countriesLabel: "países",
      including: "Incluye",
      more: "destinos más",
      note: "Cobertura en expansión continua",
      contactUs: "Consulta por un destino específico"
    },
    accountSetup: {
      pageTitle: "Registro de Cliente",
      subtitle: "Complete el perfil de su empresa para comenzar a enviar con MailAmericas",
      instruction: "Por favor complete en inglés",
      backToHome: "Volver al Inicio",
      sections: {
        clientInfo: "Información del Cliente",
        bankInfo: "Información Bancaria",
        contacts: "Contactos",
        shippingAddresses: "Direcciones de Envío"
      },
      clientInfo: {
        customerName: "Nombre del Cliente",
        companyName: "Nombre de la Empresa (Razón Social)",
        taxId: "ID Fiscal / CUIT",
        address: "Dirección",
        district: "Distrito",
        city: "Ciudad",
        state: "Estado / Provincia",
        phoneNumber: "Número de Teléfono",
        zipCode: "Código Postal",
        webpage: "Página Web"
      },
      bankInfo: {
        title: "Banco Principal",
        beneficiaryName: "Nombre del Beneficiario",
        bankName: "Nombre del Banco",
        accountNumber: "Número de Cuenta",
        bankAddress: "Dirección del Banco",
        country: "País",
        currency: "Moneda",
        swiftCode: "Código SWIFT",
        abaCode: "Código ABA",
        correspondentBank: "Banco Corresponsal",
        correspondentTitle: "Banco Corresponsal (si aplica)",
        payoneerOption: "Opción Payoneer",
        payoneerAccount: "Email de Cuenta Payoneer",
        currencyPreference: "Preferencia de Moneda"
      },
      contacts: {
        commercial: "Contacto Comercial",
        operations: "Contacto de Operaciones",
        financial: "Contacto Financiero",
        contactName: "Nombre del Contacto",
        position: "Cargo",
        phone: "Teléfono",
        cellPhone: "Celular",
        email: "E-mail",
        wechat: "WeChat",
        skype: "Skype"
      },
      shipping: {
        warehouseTitle: "Dirección de Envío",
        warehouseLegalName: "Razón Social del Almacén",
        warehouseManager: "Nombre del Encargado",
        warehousePhone: "Teléfono del Almacén",
        shippingAddress: "Dirección de Envío",
        city: "Ciudad",
        zipCode: "Código Postal",
        state: "Estado / Provincia",
        country: "País",
        addAddress: "Agregar Otra Dirección",
        removeAddress: "Eliminar"
      },
      form: {
        submit: "Enviar Solicitud",
        submitting: "Enviando...",
        success: "¡Su solicitud ha sido enviada exitosamente! Nuestro equipo lo contactará pronto.",
        error: "Hubo un error al enviar su solicitud. Por favor intente de nuevo.",
        validation: "Por favor complete los campos marcados con * y corrija los resaltados en rojo.",
        required: "Campo requerido",
        previous: "Anterior",
        next: "Siguiente",
        selectPlaceholder: "Seleccionar...",
        errors: {
          tooLong: "Demasiado largo: máximo {max} caracteres",
          text: "Contiene caracteres inválidos, o < > que no están permitidos",
          phone: "Ingrese un teléfono válido: solo dígitos y + - ( )",
          taxId: "Ingrese un ID fiscal válido: solo letras, números y - . /, con al menos un número",
          zip: "Ingrese un código postal válido: solo letras, números y - . /",
          code: "Solo se permiten letras, números, espacios y - . /",
          email: "Ingrese un e-mail válido, por ejemplo nombre@empresa.com",
          url: "Ingrese una dirección web válida, por ejemplo https://www.empresa.com",
          invalid: "Valor inválido"
        }
      }
    },
    hero: {
      title: "ENVÍOS GLOBALES",
      titleAccent: "SIMPLIFICADOS.",
      subtitle: "El socio logístico más confiable para vendedores de e-commerce en todo el mundo.",
      cta: "Comenzar a Enviar",
      ctaSecondary: "Ver Almacenes",
      stats: {
        originWarehouses: "Almacenes de Origen",
        continents: "Continentes",
        operations: "Operaciones",
        certified: "Certificado"
      }
    },
    process: {
      label: "Paso a Paso",
      title: "ENTREGA DE CARGA",
      titleAccent: "SIMPLIFICADA",
      apiAvailable: "También por API",
      clickHere: "Haga clic aquí",
      step: "PASO",
      downloadTemplate: "Descargar plantilla de BOL",
      usOps: {
        label: "Almacenes en USA",
        cta: "Dirección, horarios y detalles",
        title: "Cómo recibe carga cada almacén de USA",
        subtitle: "Las reglas de recepción cambian según el almacén. Revise la del almacén al que envía antes de planificar la entrega.",
        cols: {
          warehouse: "Almacén",
          delivery: "Forma de entrega",
          bol: "Bill of Lading (TSA)",
          dg: "Mercancías Peligrosas",
          notes: "Alcance"
        },
        delivery: {
          both: "Logística propia o carrier comercial",
          carrierOnly: "Solo carrier comercial"
        },
        bol: {
          own: "Obligatorio para entregas con logística propia",
          carrier: "No requerido: aplica la documentación del carrier"
        },
        dg: {
          yes: "Autorizado",
          no: "No se acepta"
        },
        notes: {
          miami: "Todos los destinos. Único almacén de USA autorizado para DG",
          laredo: "Solo carga con destino a México",
          carrier: "Todos los destinos. Las entregas personales se rechazan en el ingreso"
        }
      },
      steps: {
        tsa: {
          title: "Registro TSA",
          subtitle: "Solo para Carga con Origen en EE.UU.",
          description: "Regístrese en nuestro Formulario TSA para asegurar que su carga esté autorizada para viajar por aire a través de Estados Unidos."
        },
        labels: {
          title: "Generar Etiquetas",
          subtitle: "API o Plataforma",
          description: "Genere la etiqueta de envío a través de nuestra API o directamente en la plataforma de e-commerce donde vende sus productos."
        },
        prealert: {
          title: "Pre-Alerta",
          subtitle: "24h Antes de la Entrega",
          description: "Pre-alerte su carga a nuestro almacén al menos 24 horas antes de su entrega."
        },
        delivery: {
          title: "Entrega de Carga",
          subtitle: "Entregar en Almacén",
          description: "Entregue la carga durante el horario de operación, siguiendo las reglas de recepción de su almacén. Vea la tabla de almacenes de USA más abajo."
        },
        confirmation: {
          title: "Confirmación de Ingreso",
          subtitle: "Dentro de 24 Horas Hábiles",
          description: "Reciba la confirmación de ingreso dentro de 24 horas hábiles desde la entrega."
        }
      }
    },
    dangerousGoods: {
      label: "Aviso Importante",
      title: "PROTOCOLOS DE",
      titleAccent: "MERCANCÍAS PELIGROSAS",
      miamiOnly: {
        badge: "Almacén US Autorizado",
        title: "Miami es nuestro único warehouse autorizado para DG en los Estados Unidos.",
        description: "Todos los envíos de Mercancías Peligrosas (DG) gestionados a través de nuestra red en US deben dirigirse exclusivamente a nuestra facility de Miami. Nuestros otros almacenes en US — LAX, ORD y EWR — no están certificados para recibir, procesar ni despachar carga DG.",
        locationLabel: "Sitio Autorizado DG en US"
      },
      intro: "MailAmericas permite recibir Baterías de Iones de Litio bajo UN 3481 PI 967 y PI 966 Sección II, y Baterías Metálicas bajo UN 3091 PI 970 y PI 969 Sección II.",
      warning: "Importante: Algunos productos de e-commerce están clasificados como Mercancías Peligrosas (DG) bajo las regulaciones internacionales de transporte aéreo (IATA). Por favor revise sus artículos cuidadosamente antes de enviar.",
      productsTitle: "Productos comúnmente considerados DG:",
      products: [
        "Baterías de litio (sueltas, integradas o con equipo)",
        "Perfumes, sprays y cosméticos con alcohol",
        "Aerosoles (desodorantes, sprays de limpieza, etc.)",
        "Químicos, polvos, líquidos inflamables o presurizados"
      ],
      howToDeclare: "¿Cómo Declarar Mercancías Peligrosas?",
      declareOptions: [
        "Etiquetado: Identifique las cajas que contienen artículos DG aplicando la etiqueta DG apropiada.",
        "Manifiesto de Pre-alerta: Indique en la pre-alerta qué cajas específicas contienen carga DG."
      ],
      note: "MailAmericas emitirá el Certificado DG después de inspeccionar el envío en nuestro almacén."
    },
    warehouses: {
      label: "Red Global",
      title: "NUESTROS",
      titleAccent: "ALMACENES",
      subtitle: "Centros de fulfillment estratégicos en 5 continentes.",
      regions: {
        usa: "Estados Unidos",
        asia: "Asia",
        europe: "Europa",
        africa: "África",
        southamerica: "Sudamérica"
      }
    },
    network: {
      locations: "Ubicaciones",
      dgAuthorized: "AUTORIZADO DG",
      origins: "Almacenes",
      destinations: "Destinos",
      originsLabel: "Almacenes de Origen",
      destinationsLabel: "Red de Entrega",
      originsTitle: "DÓNDE",
      originsHighlight: "RECOGEMOS",
      destinationsTitle: "DÓNDE",
      destinationsHighlight: "ENTREGAMOS",
      originsSubtitle: "Puntos estratégicos de inyección en 5 continentes — tu inventario empieza aquí.",
      destinationsSubtitle: "89 países alcanzados desde nuestro hub en Miami con entrega de última milla confiable.",
      countries: "Países",
      continents: "Continentes",
      moreCountries: "y muchos más",
      fromMiami: "Desde el Hub de Miami:",
      deliveryNote: "Conexión directa a 89 países destino con tiempos de tránsito optimizados.",
      sopBadge: "SOP de Drop-off para Couriers",
      sopTitle: "Reglas Universales",
      sopSubtitle: "Lo que todo conductor debe hacer, siempre — aplica a todos nuestros almacenes en USA.",
      sopRules: [
        { t: "Presente la documentación de entrega", d: "Carriers comerciales: el Bill of Lading o comprobante de entrega propio del carrier, con el número de tracking o PRO. Logística propia (Miami, y Laredo para carga con destino a México): el Bill of Lading TSA completo, con una dirección FROM registrada como TSA Known Shipper. Un BOL por día de entrega.", download: true },
        { t: "Presentar una ID válida del gobierno", d: "Sin excepciones. No se recibirán paquetes sin verificación de identidad." },
        { t: "Rampa para vans · Dock para camiones", d: "No comience la descarga hasta que nuestro equipo confirme la asignación del dock." },
        { t: "Descargar solo en el dock asignado", d: "No en el estacionamiento, la rampa, el lobby ni en ninguna otra área. Los recibos y scans están vinculados al drop en el dock." }
      ],
      sopDocLabel: "Descargar plantilla de BOL para logística propia (PDF)",
      sopContactLabel: "Coordinación de recepción:",
      securityNotice: {
        badge: "Aviso de Seguridad",
        title: "Entrega exclusiva por carrier comercial en ORD, EWR y LAX",
        body: "Por razones de seguridad y en línea con los requisitos de seguridad de carga aérea, nuestros almacenes de Chicago (ORD), New Jersey (EWR) y Los Angeles (LAX) reciben carga exclusivamente a través de carriers comerciales. Las entregas personales, incluida la carga llevada por sellers, su personal o cualquier vehículo particular, no pueden recibirse en estas ubicaciones.",
        howTo: "Para entregar carga en estos almacenes, envíela a través de un carrier establecido de USA. Pre-alerte el envío con al menos 24 horas de anticipación e incluya el número de tracking o PRO del carrier.",
        parcelLabel: "Carriers de paquetería",
        freightLabel: "Carriers LTL y de carga",
        carriersNote: "Los carriers listados son solo recomendaciones. Puede utilizar cualquier otro carrier comercial de su preferencia, siempre que sea un carrier comercial habilitado, el envío esté pre-alertado con al menos 24 horas de anticipación y llegue con el número de tracking o PRO del carrier.",
        footnote: "Las entregas personales que lleguen a ORD, EWR o LAX serán rechazadas en el ingreso. Los procedimientos de recepción en Miami y Laredo no cambian.",
        tag: "SOLO CARRIERS"
      },
      regions: {
        usa: "Estados Unidos",
        asia: "Asia",
        europe: "Europa",
        africa: "África",
        southamerica: "Sudamérica",
        america: "América"
      }
    },
    apiDocs: {
      badge: "Recursos para Desarrolladores",
      title: "DOCUMENTACIÓN",
      titleAccent: "API",
      subtitle: "Integra MailAmericas en tu stack. Envía Pre-Alertas y genera etiquetas vía API — o usa nuestros formularios web. Tú eliges.",
      copy: "Copiar",
      copied: "¡Copiado!",
      prealert: {
        tab: "API Pre-Alertas",
        heading: "API de Pre-Alertas",
        description: "Envía pre-alertas de envíos de forma programática. Manda los datos de despacho, ETA, almacén y tracking numbers en un único POST. Las pre-alertas también están disponibles vía formulario web — usa la opción que mejor se adapte a tu flujo.",
        salesNoteLabel: "Credenciales",
        salesNote: "El endpoint de producción y tu API Key única son provistos por tu equipo Comercial de MailAmericas durante el onboarding.",
        requestBody: "Cuerpo del Request",
        exampleTitle: "request.example.json"
      },
      label: {
        tab: "API Generación de Etiquetas",
        tab2: "Etiquetas",
        heading: "API de Generación de Etiquetas v1.0",
        description: "Genera etiquetas de envío para tus paquetes de forma programática. Soporta formatos PDF y ZPL, con compliance internacional — Brasil, México, Chile, Egipto y más.",
        method: "Método",
        formats: "Formatos",
        envs: "Entornos",
        salesNote: "Las URLs de Test y Producción y los detalles de autenticación son provistos por tu equipo Comercial de MailAmericas.",
        tabs: {
          general: "General",
          package: "Paquete",
          shipper: "Remitente",
          buyer: "Comprador",
          items: "Ítems",
          cod: "COD"
        },
        annex: {
          brazil: {
            title: "Brasil — Validaciones Especiales",
            items: [
              { k: "Packet Standard", v: "máx. 30 kg, largo 15-100 cm, ancho 10-100 cm, alto 2-100 cm." },
              { k: "Packet Express", v: "máx. 30 kg, largo 15-100 cm, ancho 10-100 cm, alto 1-100 cm." },
              { k: "Packet Mini", v: "máx. 300 g, largo 16-24 cm, ancho 11-16 cm, alto 1-4 cm." },
              { k: "ID del comprador", v: "CPF (11 caracteres) o CNPJ (14 caracteres); de lo contrario se toma como pasaporte." }
            ]
          },
          others: {
            title: "Egipto, COAR, MX & CL — Extras",
            items: [
              { k: "Egipto", v: "los paquetes DDP requieren un `hs_code` válido o categoría." },
              { k: "COAR", v: "el código postal del comprador debe tener entre 4 y 8 caracteres." },
              { k: "MX y CL", v: "la respuesta incluye `returns_address`, `sorting_last_mile`, `sorting_warehouse`, `buyer_zip_code`." }
            ]
          }
        },
        businessLogic: {
          title: "Lógica de Negocio — Valor y Peso",
          description: "El sistema siempre toma el mayor de dos valores al generar etiquetas:",
          value: "Valor",
          valueDesc: "Compara el valor declarado del paquete vs la suma de valor de todos los ítems — toma el mayor.",
          weight: "Peso",
          weightDesc: "Compara el peso declarado del paquete vs la suma de peso de todos los ítems — toma el mayor."
        }
      },
      table: {
        field: "Campo",
        type: "Tipo",
        required: "Requerido",
        requiredYes: "Sí",
        requiredNo: "No",
        description: "Descripción"
      },
      response: {
        success: "Éxito",
        successNote: "Pre-alerta aceptada y procesada.",
        error: "Error",
        errorNote: "Payload inválido — revisa los campos requeridos."
      },
      cta: {
        title: "¿Listo para Integrar?",
        description: "Obtén tus credenciales API y empieza a automatizar pre-alertas y generación de etiquetas hoy. Nuestro equipo Comercial está listo para tu onboarding.",
        button: "Contacta a nuestro equipo Comercial"
      }
    },
    notFound: {
      title: "Página no encontrada",
      description: "La página que busca no existe o fue movida.",
      cta: "Volver al Inicio"
    },
    footer: {
      tagline: "Su socio logístico de confianza para e-commerce global.",
      quickLinks: "Enlaces Rápidos",
      legal: "Legal",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      contact: "Contacto",
      rights: "Todos los derechos reservados."
    }
  },
  pt: {
    lang: 'pt',
    a11y: {
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
      scrollDown: "Ir para a próxima seção",
      linkedin: "MailAmericas no LinkedIn"
    },
    nav: {
      process: "Processo",
      prealert: "Pré-Alerta",
      dangerousGoods: "DG",
      warehouses: "Armazéns",
      destinations: "Destinos",
      fulfillment: "Fulfillment",
      returns: "Devoluções",
      contact: "Contato",
      shipWithUs: "Envie conosco",
      accountSetup: "Cadastro",
      apiDocs: "API Docs"
    },
    fulfillment: {
      integrated: "Integrado",
      badge: "Centro de Fulfillment",
      title: "Fulfillment Miami",
      subtitle: "Seu hub estratégico para conquistar o mercado americano. Armazene, prepare e envie do coração das Américas com conexão direta a todos os marketplaces.",
      operations: "Operações",
      connectedTo: "Conectado a todos os marketplaces",
      moreMarketplaces: "E muitas plataformas mais",
      customIntegration: "Também podemos integrar seu e-commerce de forma personalizada.",
      marketplaces: {
        badge: "Integrações de Marketplace",
        title: "Conecte-se a",
        titleAccent: "todos os canais que importam",
        subtitle: "Dos maiores marketplaces das Américas até sua própria loja personalizada — um único inventário, um único centro de fulfillment."
      },
      ctaBadge: "Consulta gratuita",
      ctaTitle: "Pronto para escalar seu e-commerce?",
      ctaDesc: "Deixe sua logística conosco enquanto você foca em fazer seu negócio crescer. Receba uma cotação personalizada para suas necessidades de fulfillment.",
      ctaButton: "Solicitar cotação",
      ctaSubtext: "Resposta em até 24 horas úteis"
    },
    destinations: {
      badge: "Rede de Entregas",
      title: "Onde Entregamos",
      subtitle: "De Miami para o mundo. Seus pacotes chegam a 89 países em 3 continentes com entrega de última milha confiável.",
      subtitle2: "Entrega de última milha mundial",
      countries: "países",
      continents: "Continentes",
      countriesLabel: "países",
      including: "Incluindo",
      more: "destinos mais",
      note: "Cobertura em expansão contínua",
      contactUs: "Consulte sobre um destino específico"
    },
    accountSetup: {
      pageTitle: "Cadastro de Cliente",
      subtitle: "Complete o perfil da sua empresa para começar a enviar com a MailAmericas",
      instruction: "Por favor preencha em inglês",
      backToHome: "Voltar ao Início",
      sections: {
        clientInfo: "Informações do Cliente",
        bankInfo: "Informações Bancárias",
        contacts: "Contatos",
        shippingAddresses: "Endereços de Envio"
      },
      clientInfo: {
        customerName: "Nome do Cliente",
        companyName: "Nome da Empresa (Razão Social)",
        taxId: "CNPJ / ID Fiscal",
        address: "Endereço",
        district: "Bairro",
        city: "Cidade",
        state: "Estado",
        phoneNumber: "Número de Telefone",
        zipCode: "CEP",
        webpage: "Website"
      },
      bankInfo: {
        title: "Banco Principal",
        beneficiaryName: "Nome do Beneficiário",
        bankName: "Nome do Banco",
        accountNumber: "Número da Conta",
        bankAddress: "Endereço do Banco",
        country: "País",
        currency: "Moeda",
        swiftCode: "Código SWIFT",
        abaCode: "Código ABA",
        correspondentBank: "Banco Correspondente",
        correspondentTitle: "Banco Correspondente (se aplicável)",
        payoneerOption: "Opção Payoneer",
        payoneerAccount: "Email da Conta Payoneer",
        currencyPreference: "Preferência de Moeda"
      },
      contacts: {
        commercial: "Contato Comercial",
        operations: "Contato de Operações",
        financial: "Contato Financeiro",
        contactName: "Nome do Contato",
        position: "Cargo",
        phone: "Telefone",
        cellPhone: "Celular",
        email: "E-mail",
        wechat: "WeChat",
        skype: "Skype"
      },
      shipping: {
        warehouseTitle: "Endereço de Envio",
        warehouseLegalName: "Razão Social do Armazém",
        warehouseManager: "Nome do Gerente",
        warehousePhone: "Telefone do Armazém",
        shippingAddress: "Endereço de Envio",
        city: "Cidade",
        zipCode: "CEP",
        state: "Estado",
        country: "País",
        addAddress: "Adicionar Outro Endereço",
        removeAddress: "Remover"
      },
      form: {
        submit: "Enviar Cadastro",
        submitting: "Enviando...",
        success: "Seu cadastro foi enviado com sucesso! Nossa equipe entrará em contato em breve.",
        error: "Houve um erro ao enviar seu cadastro. Por favor, tente novamente.",
        validation: "Por favor preencha os campos marcados com * e corrija os destacados em vermelho.",
        required: "Campo obrigatório",
        previous: "Anterior",
        next: "Próximo",
        selectPlaceholder: "Selecionar...",
        errors: {
          tooLong: "Muito longo: máximo de {max} caracteres",
          text: "Contém caracteres inválidos, ou < > que não são permitidos",
          phone: "Informe um telefone válido: apenas dígitos e + - ( )",
          taxId: "Informe um ID fiscal válido: apenas letras, números e - . /, com pelo menos um número",
          zip: "Informe um CEP válido: apenas letras, números e - . /",
          code: "Apenas letras, números, espaços e - . / são permitidos",
          email: "Informe um e-mail válido, por exemplo nome@empresa.com",
          url: "Informe um endereço web válido, por exemplo https://www.empresa.com",
          invalid: "Valor inválido"
        }
      }
    },
    hero: {
      title: "ENVIOS GLOBAIS",
      titleAccent: "SIMPLIFICADOS.",
      subtitle: "O parceiro logístico mais confiável para vendedores de e-commerce em todo o mundo.",
      cta: "Começar a Enviar",
      ctaSecondary: "Ver Armazéns",
      stats: {
        originWarehouses: "Armazéns de Origem",
        continents: "Continentes",
        operations: "Operações",
        certified: "Certificado"
      }
    },
    process: {
      label: "Passo a Passo",
      title: "ENTREGA DE CARGA",
      titleAccent: "SIMPLIFICADA",
      apiAvailable: "Também via API",
      clickHere: "Clique aqui",
      step: "ETAPA",
      downloadTemplate: "Baixar modelo de BOL",
      usOps: {
        label: "Armazéns nos EUA",
        cta: "Endereço, horários e detalhes",
        title: "Como cada armazém dos EUA recebe carga",
        subtitle: "As regras de recebimento variam por armazém. Confira as do armazém de destino antes de planejar a entrega.",
        cols: {
          warehouse: "Armazém",
          delivery: "Forma de entrega",
          bol: "Bill of Lading (TSA)",
          dg: "Mercadorias Perigosas",
          notes: "Escopo"
        },
        delivery: {
          both: "Logística própria ou carrier comercial",
          carrierOnly: "Somente carrier comercial"
        },
        bol: {
          own: "Obrigatório para entregas com logística própria",
          carrier: "Não exigido: vale a documentação do carrier"
        },
        dg: {
          yes: "Autorizado",
          no: "Não aceito"
        },
        notes: {
          miami: "Todos os destinos. Único armazém nos EUA autorizado para DG",
          laredo: "Somente carga com destino ao México",
          carrier: "Todos os destinos. Entregas pessoais são recusadas na entrada"
        }
      },
      steps: {
        tsa: {
          title: "Registro TSA",
          subtitle: "Apenas para Carga com Origem nos EUA",
          description: "Registre-se em nosso Formulário TSA para garantir que sua carga esteja autorizada a viajar por ar através dos Estados Unidos."
        },
        labels: {
          title: "Gerar Etiquetas",
          subtitle: "API ou Plataforma",
          description: "Gere a etiqueta de envio através de nossa API ou diretamente na plataforma de e-commerce onde você vende seus produtos."
        },
        prealert: {
          title: "Pré-Alerta",
          subtitle: "24h Antes da Entrega",
          description: "Pré-alerte sua carga para nosso armazém pelo menos 24 horas antes da entrega."
        },
        delivery: {
          title: "Entrega de Carga",
          subtitle: "Entregar no Armazém",
          description: "Entregue a carga durante o horário de operação, seguindo as regras de recebimento do seu armazém. Veja a tabela de armazéns dos EUA abaixo."
        },
        confirmation: {
          title: "Confirmação de Entrada",
          subtitle: "Dentro de 24 Horas Úteis",
          description: "Receba a confirmação de entrada dentro de 24 horas úteis a partir da entrega."
        }
      }
    },
    dangerousGoods: {
      label: "Aviso Importante",
      title: "PROTOCOLOS DE",
      titleAccent: "MERCADORIAS PERIGOSAS",
      miamiOnly: {
        badge: "Armazém US Autorizado",
        title: "Miami é o nosso único armazém autorizado para DG nos Estados Unidos.",
        description: "Todos os envios de Mercadorias Perigosas (DG) gerenciados através da nossa rede nos EUA devem ser direcionados exclusivamente à nossa unidade de Miami. Nossos outros armazéns nos EUA — LAX, ORD e EWR — não estão certificados para receber, processar ou despachar carga DG.",
        locationLabel: "Site Autorizado DG nos EUA"
      },
      intro: "MailAmericas permite receber Baterias de Íons de Lítio sob UN 3481 PI 967 e PI 966 Seção II, e Baterias Metálicas sob UN 3091 PI 970 e PI 969 Seção II.",
      warning: "Importante: Alguns produtos de e-commerce são classificados como Mercadorias Perigosas (DG) sob os regulamentos internacionais de transporte aéreo (IATA). Por favor, revise seus itens cuidadosamente antes de enviar.",
      productsTitle: "Produtos comumente considerados DG:",
      products: [
        "Baterias de lítio (soltas, embutidas ou com equipamento)",
        "Perfumes, sprays e cosméticos contendo álcool",
        "Aerossóis (desodorantes, sprays de limpeza, etc.)",
        "Químicos, pós, líquidos inflamáveis ou pressurizados"
      ],
      howToDeclare: "Como Declarar Mercadorias Perigosas?",
      declareOptions: [
        "Etiquetagem: Identifique as caixas contendo itens DG aplicando a etiqueta DG apropriada.",
        "Manifesto de Pré-alerta: Indique no pré-alerta quais caixas específicas contêm carga DG."
      ],
      note: "MailAmericas emitirá o Certificado DG após inspecionar o envio em nosso armazém."
    },
    warehouses: {
      label: "Rede Global",
      title: "NOSSOS",
      titleAccent: "ARMAZÉNS",
      subtitle: "Centros de fulfillment estratégicos em 5 continentes.",
      regions: {
        usa: "Estados Unidos",
        asia: "Ásia",
        europe: "Europa",
        africa: "África",
        southamerica: "América do Sul"
      }
    },
    network: {
      locations: "Localizações",
      dgAuthorized: "AUTORIZADO DG",
      origins: "Armazéns",
      destinations: "Destinos",
      originsLabel: "Armazéns de Origem",
      destinationsLabel: "Rede de Entrega",
      originsTitle: "ONDE",
      originsHighlight: "COLETAMOS",
      destinationsTitle: "ONDE",
      destinationsHighlight: "ENTREGAMOS",
      originsSubtitle: "Pontos estratégicos de injeção em 5 continentes — seu inventário começa aqui.",
      destinationsSubtitle: "89 países alcançados a partir do nosso hub em Miami com entrega de última milha confiável.",
      countries: "Países",
      continents: "Continentes",
      moreCountries: "e muitos mais",
      fromMiami: "Do Hub de Miami:",
      deliveryNote: "Conexão direta a 89 países destino com tempos de trânsito otimizados.",
      sopBadge: "SOP de Drop-off para Carriers",
      sopTitle: "Regras Universais",
      sopSubtitle: "O que todo motorista deve fazer, sempre — aplica-se a todos os nossos armazéns nos EUA.",
      sopRules: [
        { t: "Apresente a documentação de entrega", d: "Carriers comerciais: o Bill of Lading ou comprovante de entrega do próprio carrier, com o número de rastreamento ou PRO. Logística própria (Miami, e Laredo para carga com destino ao México): o Bill of Lading TSA preenchido, com um endereço FROM registrado como TSA Known Shipper. Um BOL por dia de entrega.", download: true },
        { t: "Apresente uma identidade válida emitida pelo governo", d: "Sem exceções. Pacotes não serão recebidos sem verificação de identidade." },
        { t: "Rampa para vans · Doca para caminhões", d: "Não inicie a descarga até que nossa equipe confirme a atribuição da doca." },
        { t: "Descarregue apenas na doca atribuída", d: "Não no estacionamento, na rampa, no lobby nem em qualquer outra área. Recibos e scans estão atrelados à descarga na doca." }
      ],
      sopDocLabel: "Baixar modelo de BOL para logística própria (PDF)",
      sopContactLabel: "Coordenação de recebimento:",
      securityNotice: {
        badge: "Aviso de Segurança",
        title: "Entrega exclusiva por carrier comercial em ORD, EWR e LAX",
        body: "Por razões de segurança e em conformidade com os requisitos de segurança de carga aérea, nossos armazéns de Chicago (ORD), New Jersey (EWR) e Los Angeles (LAX) recebem carga exclusivamente por meio de carriers comerciais. Entregas pessoais, incluindo cargas levadas por sellers, sua equipe ou qualquer veículo particular, não podem ser recebidas nesses locais.",
        howTo: "Para entregar carga nesses armazéns, envie-a por meio de um carrier estabelecido nos EUA. Pré-alerte o envio com pelo menos 24 horas de antecedência e inclua o número de rastreamento ou PRO do carrier.",
        parcelLabel: "Carriers de encomendas",
        freightLabel: "Carriers LTL e de carga",
        carriersNote: "Os carriers listados são apenas recomendações. Você pode utilizar qualquer outro carrier comercial de sua preferência, desde que seja um carrier comercial habilitado, o envio seja pré-alertado com pelo menos 24 horas de antecedência e chegue com o número de rastreamento ou PRO do carrier.",
        footnote: "Entregas pessoais que chegarem a ORD, EWR ou LAX serão recusadas na entrada. Os procedimentos de recebimento em Miami e Laredo não mudam.",
        tag: "SOMENTE CARRIERS"
      },
      regions: {
        usa: "Estados Unidos",
        asia: "Ásia",
        europe: "Europa",
        africa: "África",
        southamerica: "América do Sul",
        america: "Américas"
      }
    },
    apiDocs: {
      badge: "Recursos para Desenvolvedores",
      title: "DOCUMENTAÇÃO",
      titleAccent: "API",
      subtitle: "Integre MailAmericas na sua stack. Envie Pré-Alertas e gere etiquetas via API — ou use nossos formulários web. Você escolhe.",
      copy: "Copiar",
      copied: "Copiado!",
      prealert: {
        tab: "API Pré-Alertas",
        heading: "API de Pré-Alertas",
        description: "Envie pré-alertas de envios de forma programática. Envie dados de despacho, ETA, armazém e tracking numbers num único POST. Pré-alertas também estão disponíveis via formulário web — use o que melhor se adapte ao seu fluxo.",
        salesNoteLabel: "Credenciais",
        salesNote: "O endpoint de produção e sua API Key única são fornecidos pela equipe Comercial da MailAmericas durante o onboarding.",
        requestBody: "Corpo da Requisição",
        exampleTitle: "request.example.json"
      },
      label: {
        tab: "API Geração de Etiquetas",
        tab2: "Etiquetas",
        heading: "API de Geração de Etiquetas v1.0",
        description: "Gere etiquetas de envio para seus pacotes de forma programática. Suporta formatos PDF e ZPL, com compliance internacional — Brasil, México, Chile, Egito e mais.",
        method: "Método",
        formats: "Formatos",
        envs: "Ambientes",
        salesNote: "URLs de Teste e Produção e detalhes de autenticação são fornecidos pela equipe Comercial da MailAmericas.",
        tabs: {
          general: "Geral",
          package: "Pacote",
          shipper: "Remetente",
          buyer: "Comprador",
          items: "Itens",
          cod: "COD"
        },
        annex: {
          brazil: {
            title: "Brasil — Validações Especiais",
            items: [
              { k: "Packet Standard", v: "máx. 30 kg, comprimento 15-100 cm, largura 10-100 cm, altura 2-100 cm." },
              { k: "Packet Express", v: "máx. 30 kg, comprimento 15-100 cm, largura 10-100 cm, altura 1-100 cm." },
              { k: "Packet Mini", v: "máx. 300 g, comprimento 16-24 cm, largura 11-16 cm, altura 1-4 cm." },
              { k: "ID do comprador", v: "CPF (11 caracteres) ou CNPJ (14 caracteres); caso contrário, é considerado passaporte." }
            ]
          },
          others: {
            title: "Egito, COAR, MX & CL — Extras",
            items: [
              { k: "Egito", v: "pacotes DDP exigem `hs_code` válido ou categoria." },
              { k: "COAR", v: "o CEP do comprador deve ter de 4 a 8 caracteres." },
              { k: "MX e CL", v: "a resposta inclui `returns_address`, `sorting_last_mile`, `sorting_warehouse`, `buyer_zip_code`." }
            ]
          }
        },
        businessLogic: {
          title: "Lógica de Negócio — Valor e Peso",
          description: "O sistema sempre pega o maior entre dois valores ao gerar etiquetas:",
          value: "Valor",
          valueDesc: "Compara o valor declarado do pacote vs a soma do valor de todos os itens — pega o maior.",
          weight: "Peso",
          weightDesc: "Compara o peso declarado do pacote vs a soma do peso de todos os itens — pega o maior."
        }
      },
      table: {
        field: "Campo",
        type: "Tipo",
        required: "Obrigatório",
        requiredYes: "Sim",
        requiredNo: "Não",
        description: "Descrição"
      },
      response: {
        success: "Sucesso",
        successNote: "Pré-alerta aceito e processado.",
        error: "Erro",
        errorNote: "Payload inválido — verifique os campos obrigatórios."
      },
      cta: {
        title: "Pronto para Integrar?",
        description: "Obtenha suas credenciais de API e comece a automatizar pré-alertas e geração de etiquetas hoje. Nossa equipe Comercial está pronta para seu onboarding.",
        button: "Contate nossa equipe Comercial"
      }
    },
    notFound: {
      title: "Página não encontrada",
      description: "A página que você procura não existe ou foi movida.",
      cta: "Voltar ao Início"
    },
    footer: {
      tagline: "Seu parceiro logístico de confiança para e-commerce global.",
      quickLinks: "Links Rápidos",
      legal: "Legal",
      privacy: "Política de Privacidade",
      terms: "Termos de Serviço",
      contact: "Contato",
      rights: "Todos os direitos reservados."
    }
  },
  zh: {
    lang: 'zh',
    a11y: {
      openMenu: "打开菜单",
      closeMenu: "关闭菜单",
      scrollDown: "滚动到下一部分",
      linkedin: "MailAmericas 领英主页"
    },
    nav: {
      process: "流程",
      prealert: "预报",
      dangerousGoods: "危险品",
      warehouses: "仓库",
      destinations: "目的地",
      fulfillment: "履约中心",
      returns: "退货",
      contact: "联系",
      shipWithUs: "与我们合作",
      accountSetup: "账户注册",
      apiDocs: "API 文档"
    },
    fulfillment: {
      integrated: "已集成",
      badge: "履约中心",
      title: "迈阿密履约中心",
      subtitle: "您征服美洲市场的战略枢纽。从美洲心脏地带存储、备货并发货,直连所有主流电商平台。",
      operations: "运营",
      connectedTo: "连接所有主流电商平台",
      moreMarketplaces: "还有更多平台",
      customIntegration: "我们也可以为您定制电商集成方案。",
      marketplaces: {
        badge: "电商平台集成",
        title: "接入",
        titleAccent: "每一个重要的销售渠道",
        subtitle: "从美洲最大的电商平台到您自己的定制商店——一个库存,一个履约中心。"
      },
      ctaBadge: "免费咨询",
      ctaTitle: "准备好扩展您的电商业务了吗?",
      ctaDesc: "让我们处理您的物流,您专注于业务增长。获取符合您履约需求的个性化报价。",
      ctaButton: "申请报价",
      ctaSubtext: "24 个工作小时内回复"
    },
    destinations: {
      badge: "配送网络",
      title: "我们的配送范围",
      subtitle: "从迈阿密到世界。您的包裹可送达 3 大洲 89 个国家,提供可靠的最后一公里配送服务。",
      subtitle2: "全球最后一公里配送",
      countries: "国家",
      continents: "大洲",
      countriesLabel: "国家",
      including: "包括",
      more: "更多目的地",
      note: "覆盖范围持续扩展",
      contactUs: "咨询特定目的地"
    },
    accountSetup: {
      pageTitle: "客户注册",
      subtitle: "完善您的公司资料,开始使用 MailAmericas 发货",
      instruction: "请使用英文填写",
      backToHome: "返回首页",
      sections: {
        clientInfo: "客户信息",
        bankInfo: "银行信息",
        contacts: "联系人",
        shippingAddresses: "发货地址"
      },
      clientInfo: {
        customerName: "客户姓名",
        companyName: "公司名称(法定名称)",
        taxId: "税号 / 营业执照号",
        address: "地址",
        district: "区/县",
        city: "城市",
        state: "省/州",
        phoneNumber: "电话号码",
        zipCode: "邮政编码",
        webpage: "网站"
      },
      bankInfo: {
        title: "主要银行",
        beneficiaryName: "受益人姓名",
        bankName: "银行名称",
        accountNumber: "账号",
        bankAddress: "银行地址",
        country: "国家",
        currency: "货币",
        swiftCode: "SWIFT 代码",
        abaCode: "ABA 代码",
        correspondentBank: "代理银行",
        correspondentTitle: "代理银行(如适用)",
        payoneerOption: "Payoneer 选项",
        payoneerAccount: "Payoneer 账户邮箱",
        currencyPreference: "货币偏好"
      },
      contacts: {
        commercial: "商务联系人",
        operations: "运营联系人",
        financial: "财务联系人",
        contactName: "联系人姓名",
        position: "职位",
        phone: "电话",
        cellPhone: "手机",
        email: "邮箱",
        wechat: "微信",
        skype: "Skype"
      },
      shipping: {
        warehouseTitle: "发货地址",
        warehouseLegalName: "仓库法定名称",
        warehouseManager: "仓库经理姓名",
        warehousePhone: "仓库电话",
        shippingAddress: "发货地址",
        city: "城市",
        zipCode: "邮政编码",
        state: "省/州",
        country: "国家",
        addAddress: "添加另一个地址",
        removeAddress: "删除"
      },
      form: {
        submit: "提交申请",
        submitting: "提交中...",
        success: "您的申请已成功提交!我们的团队将尽快与您联系。",
        error: "提交申请时出错,请重试。",
        validation: "请填写标有 * 的字段,并更正以红色突出显示的字段。",
        required: "必填项",
        previous: "上一步",
        next: "下一步",
        selectPlaceholder: "请选择...",
        errors: {
          tooLong: "内容过长:最多 {max} 个字符",
          text: "包含无效字符,或不允许使用的 < >",
          phone: "请输入有效的电话号码:仅限数字和 + - ( )",
          taxId: "请输入有效的税号:仅限字母、数字和 - . /,且至少包含一个数字",
          zip: "请输入有效的邮政编码:仅限字母、数字和 - . /",
          code: "仅允许使用字母、数字、空格和 - . /",
          email: "请输入有效的邮箱地址,例如 name@company.com",
          url: "请输入有效的网址,例如 https://www.company.com",
          invalid: "无效的值"
        }
      }
    },
    hero: {
      title: "全球航运",
      titleAccent: "更简单。",
      subtitle: "全球电商卖家最可靠的物流合作伙伴。",
      cta: "立即开始发货",
      ctaSecondary: "查看仓库",
      stats: {
        originWarehouses: "起运仓库",
        continents: "大洲",
        operations: "运营",
        certified: "认证"
      }
    },
    process: {
      label: "分步流程",
      title: "货物交付",
      titleAccent: "化繁为简",
      apiAvailable: "也支持 API",
      clickHere: "点击这里",
      step: "步骤",
      downloadTemplate: "下载 BOL 模板",
      usOps: {
        label: "美国仓库",
        cta: "地址、营业时间及详情",
        title: "美国各仓库的收货方式",
        subtitle: "各仓库的收货规则不同。安排送货前,请先确认目标仓库的规则。",
        cols: {
          warehouse: "仓库",
          delivery: "送货方式",
          bol: "提单 (TSA)",
          dg: "危险品",
          notes: "适用范围"
        },
        delivery: {
          both: "自有物流或商业承运商",
          carrierOnly: "仅限商业承运商"
        },
        bol: {
          own: "自有物流送货时必须提供",
          carrier: "无需提供:以承运商单据为准"
        },
        dg: {
          yes: "已授权",
          no: "不接收"
        },
        notes: {
          miami: "所有目的地。美国唯一获授权处理危险品的仓库",
          laredo: "仅限发往墨西哥的货物",
          carrier: "所有目的地。个人送货将在门口被拒收"
        }
      },
      steps: {
        tsa: {
          title: "TSA 注册",
          subtitle: "仅限美国起运货物",
          description: "请在我们的 TSA 表格中注册,以确保您的货物可以通过美国空运。"
        },
        labels: {
          title: "生成面单",
          subtitle: "API 或平台",
          description: "通过我们的 API 或您销售产品的电商平台直接生成发货面单。"
        },
        prealert: {
          title: "预报",
          subtitle: "交货前 24 小时",
          description: "在交货前至少 24 小时向我们的仓库预报您的货物。"
        },
        delivery: {
          title: "货物交付",
          subtitle: "交付到仓库",
          description: "请在营业时间内按照目标仓库的收货规则交付货物。详见下方美国仓库对照表。"
        },
        confirmation: {
          title: "入库确认",
          subtitle: "24 个工作小时内",
          description: "在交付后 24 个工作小时内收到入库确认。"
        }
      }
    },
    dangerousGoods: {
      label: "重要提示",
      title: "危险品",
      titleAccent: "操作规范",
      miamiOnly: {
        badge: "美国授权仓库",
        title: "迈阿密是我们在美国唯一获得授权处理危险品的仓库。",
        description: "所有经由我们美国网络处理的危险品(DG)货物必须仅发往我们的迈阿密仓库。我们在美国的其他仓库——LAX、ORD 和 EWR——均未获得接收、处理或发运危险品货物的认证。",
        locationLabel: "美国 DG 授权站点"
      },
      intro: "MailAmericas 允许接收符合 UN 3481 PI 967 和 PI 966 第 II 部分的锂离子电池,以及符合 UN 3091 PI 970 和 PI 969 第 II 部分的金属锂电池。",
      warning: "重要提示:某些电商产品根据国际航空运输协会(IATA)条例被列为危险品(DG)。请在发货前仔细审核您的物品。",
      productsTitle: "常被视为危险品的产品:",
      products: [
        "锂电池(独立、内置或与设备一起)",
        "含酒精的香水、喷雾和化妆品",
        "气雾剂(除臭剂、清洁喷雾等)",
        "化学品、粉末、易燃或加压液体"
      ],
      howToDeclare: "如何申报危险品?",
      declareOptions: [
        "贴标:在装有危险品的箱子上贴上相应的危险品标签。",
        "预报清单:在预报中指明哪些具体箱子装有危险品。"
      ],
      note: "MailAmericas 将在仓库检查货物后签发危险品证书。"
    },
    warehouses: {
      label: "全球网络",
      title: "我们的",
      titleAccent: "仓库",
      subtitle: "5 大洲的战略性履约中心。",
      regions: {
        usa: "美国",
        asia: "亚洲",
        europe: "欧洲",
        africa: "非洲",
        southamerica: "南美洲"
      }
    },
    network: {
      locations: "地点",
      dgAuthorized: "DG 授权",
      origins: "仓库",
      destinations: "目的地",
      originsLabel: "起运仓库",
      destinationsLabel: "配送网络",
      originsTitle: "从哪里",
      originsHighlight: "收货",
      destinationsTitle: "送达",
      destinationsHighlight: "目的地",
      originsSubtitle: "5 大洲的战略投放点——您的库存从这里开始。",
      destinationsSubtitle: "从迈阿密枢纽覆盖全球 89 个国家,提供可靠的最后一公里配送。",
      countries: "国家",
      continents: "大洲",
      moreCountries: "还有更多",
      fromMiami: "从迈阿密枢纽:",
      deliveryNote: "直连 89 个目的国,优化运输时效。",
      sopBadge: "承运商送货 SOP",
      sopTitle: "通用规则",
      sopSubtitle: "每位司机每次都必须遵守 — 适用于我们在美国的所有仓库。",
      sopRules: [
        { t: "携带相应的送货单据", d: "商业承运商:承运商自己的提单或送货回执,并注明追踪号或 PRO 号。自有物流(迈阿密;拉雷多仅限发往墨西哥的货物):填妥的 TSA 提单,FROM 地址须为已备案的 TSA Known Shipper 地址。每个送货日一份 BOL。", download: true },
        { t: "出示有效的政府颁发证件", d: "无例外。未经身份验证不接收任何包裹。" },
        { t: "厢式货车用斜坡 · 卡车用码头", d: "在我方团队确认码头分配前请勿开始卸货。" },
        { t: "仅在指定码头卸货", d: "不在停车场、斜坡、大堂或任何其他区域。回执和入库扫描均绑定到该码头的卸货。" }
      ],
      sopDocLabel: "下载自有物流 BOL 模板 (PDF)",
      sopContactLabel: "收货协调:",
      securityNotice: {
        badge: "安全通知",
        title: "ORD、EWR 和 LAX 仓库仅接受商业承运商送货",
        body: "出于安全原因并根据航空货运安全要求,我们位于芝加哥 (ORD)、新泽西 (EWR) 和洛杉矶 (LAX) 的仓库仅通过商业承运商接收货物。上述仓库无法接收个人送货,包括由卖家、其员工或任何私人车辆送达的货物。",
        howTo: "如需向上述仓库交付货物,请通过美国正规承运商发货。请至少提前 24 小时预报货物,并提供承运商的追踪号或 PRO 号。",
        parcelLabel: "包裹承运商",
        freightLabel: "零担 (LTL) 及货运承运商",
        carriersNote: "以上所列承运商仅供参考。您也可以选择任何其他商业承运商,前提是该承运商为持证的商业承运商、货物至少提前 24 小时完成预报,并在送达时提供承运商的追踪号或 PRO 号。",
        footnote: "抵达 ORD、EWR 或 LAX 的个人送货将在门口被拒收。迈阿密和拉雷多仓库的收货流程保持不变。",
        tag: "仅限承运商"
      },
      regions: {
        usa: "美国",
        asia: "亚洲",
        europe: "欧洲",
        africa: "非洲",
        southamerica: "南美洲",
        america: "美洲"
      }
    },
    apiDocs: {
      badge: "开发者资源",
      title: "API",
      titleAccent: "文档",
      subtitle: "将 MailAmericas 集成到您的技术栈。通过 API 发送预报和生成面单——或使用我们的网页表单。由您选择。",
      copy: "复制",
      copied: "已复制!",
      prealert: {
        tab: "预报 API",
        heading: "预报提交 API",
        description: "以编程方式提交货物预报。在一个 POST 请求中发送发货数据、ETA、仓库和追踪号。预报也可通过网页表单提交——选择最适合您工作流程的方式。",
        salesNoteLabel: "凭证",
        salesNote: "生产环境端点和您专属的 API Key 将由 MailAmericas 商务团队在入网时提供。",
        requestBody: "请求体",
        exampleTitle: "request.example.json"
      },
      label: {
        tab: "面单生成 API",
        tab2: "面单",
        heading: "包裹面单生成 API v1.0",
        description: "以编程方式为您的包裹生成发货面单。支持 PDF 和 ZPL 格式,符合国际合规要求——巴西、墨西哥、智利、埃及等。",
        method: "方法",
        formats: "格式",
        envs: "环境",
        salesNote: "测试和生产环境 URL 以及认证详情由 MailAmericas 商务团队提供。",
        tabs: {
          general: "通用",
          package: "包裹",
          shipper: "发货人",
          buyer: "买家",
          items: "商品",
          cod: "COD"
        },
        annex: {
          brazil: {
            title: "巴西 — 特殊验证",
            items: [
              { k: "Packet Standard", v: "最大 30kg,长 15-100cm,宽 10-100cm,高 2-100cm。" },
              { k: "Packet Express", v: "最大 30kg,长 15-100cm,宽 10-100cm,高 1-100cm。" },
              { k: "Packet Mini", v: "最大 300g,长 16-24cm,宽 11-16cm,高 1-4cm。" },
              { k: "买家 ID", v: "CPF(11 位)或 CNPJ(14 位),否则视为护照。" }
            ]
          },
          others: {
            title: "埃及、COAR、MX 和 CL — 附加",
            items: [
              { k: "埃及", v: "DDP 包裹需要有效的 `hs_code` 或类别。" },
              { k: "COAR", v: "买家邮政编码必须为 4-8 个字符。" },
              { k: "MX 和 CL", v: "响应包含 `returns_address`、`sorting_last_mile`、`sorting_warehouse`、`buyer_zip_code`。" }
            ]
          }
        },
        businessLogic: {
          title: "业务逻辑 — 价值与重量",
          description: "系统在生成面单时始终采用以下两个值中的较大者:",
          value: "价值",
          valueDesc: "比较申报的包裹价值与所有商品价值总和——取较大者。",
          weight: "重量",
          weightDesc: "比较申报的包裹重量与所有商品重量总和——取较大者。"
        }
      },
      table: {
        field: "字段",
        type: "类型",
        required: "必填",
        requiredYes: "是",
        requiredNo: "否",
        description: "描述"
      },
      response: {
        success: "成功",
        successNote: "预报已接受并处理。",
        error: "错误",
        errorNote: "无效的载荷——请检查必填字段。"
      },
      cta: {
        title: "准备好集成了吗?",
        description: "立即获取您的 API 凭证,开始自动化预报和面单生成。我们的商务团队随时准备为您服务。",
        button: "联系我们的商务团队"
      }
    },
    notFound: {
      title: "页面未找到",
      description: "您访问的页面不存在或已被移动。",
      cta: "返回首页"
    },
    footer: {
      tagline: "您值得信赖的全球电商物流合作伙伴。",
      quickLinks: "快速链接",
      legal: "法律",
      privacy: "隐私政策",
      terms: "服务条款",
      contact: "联系我们",
      rights: "版权所有。"
    }
  }
};

export const warehouseData = [
  // USA
  {
    id: 'miami',
    name: 'Miami',
    region: 'usa',
    lat: 25.7617,
    lng: -80.1918,
    address: '9910 NW 21st street Miami, FL 33172',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm | Sat: 9:00 am – 12:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm | Sáb: 9:00 am – 12:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm | Sáb: 9:00 am – 12:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00 | 周六:上午 9:00 – 中午 12:00'
    },
    dgAuthorized: true
  },
  {
    id: 'newjersey',
    name: 'New Jersey',
    region: 'usa',
    lat: 40.4976,
    lng: -74.4885,
    address: '245 Belmont Dr, Suite 1, Somerset, NJ 08873 · USA',
    hours: {
      en: 'Sun-Fri: 2:00 am – 2:00 pm',
      es: 'Dom-Vie: 2:00 am – 2:00 pm',
      pt: 'Dom-Sex: 2:00 am – 2:00 pm',
      zh: '周日至周五:凌晨 2:00 – 下午 2:00'
    },
    hub: 'EWR',
    carrierOnly: true
  },
  {
    id: 'chicago',
    name: 'Chicago',
    region: 'usa',
    lat: 42.0040,
    lng: -87.9820,
    address: '222 E. Devon Ave, Elk Grove Village, IL 60007 · USA',
    hours: {
      en: 'Mon-Fri: 5:00 am – 5:00 pm',
      es: 'Lun-Vie: 5:00 am – 5:00 pm',
      pt: 'Seg-Sex: 5:00 am – 5:00 pm',
      zh: '周一至周五:上午 5:00 – 下午 5:00'
    },
    hub: 'ORD',
    carrierOnly: true
  },
  {
    id: 'losangeles',
    name: 'Los Angeles',
    region: 'usa',
    lat: 33.8600,
    lng: -118.2265,
    address: '18301 S. Broadwick Street, Rancho Dominguez, CA 90220 · USA',
    hours: {
      en: 'Mon-Fri: 5:00 am – 5:00 pm',
      es: 'Lun-Vie: 5:00 am – 5:00 pm',
      pt: 'Seg-Sex: 5:00 am – 5:00 pm',
      zh: '周一至周五:上午 5:00 – 下午 5:00'
    },
    hub: 'LAX',
    carrierOnly: true
  },
  {
    id: 'laredo',
    name: 'Laredo',
    region: 'usa',
    lat: 27.5306,
    lng: -99.4803,
    address: '810 NAFTA BLVD, LAREDO, TX, 78045',
    hours: {
      en: 'Mon-Fri: 9:00 am – 5:30 pm',
      es: 'Lun-Vie: 9:00 am – 5:30 pm',
      pt: 'Seg-Sex: 9:00 am – 5:30 pm',
      zh: '周一至周五:上午 9:00 – 下午 5:30'
    },
    scopeTag: {
      en: 'MEXICO ONLY',
      es: 'SOLO MÉXICO',
      pt: 'SOMENTE MÉXICO',
      zh: '仅限墨西哥'
    }
  },
  // Asia
  {
    id: 'dongguan',
    name: 'Dongguan',
    region: 'asia',
    lat: 22.9954,
    lng: 113.7620,
    address: '广东省东莞市厚街镇三屯综合市场港口大道和勤电子厂中外运三楼',
    phone: '133 8864 0562',
    hours: {
      en: 'Daily: 8:00 am – 7:00 pm',
      es: 'Diario: 8:00 am – 7:00 pm',
      pt: 'Diário: 8:00 am – 7:00 pm',
      zh: '每日:上午 8:00 – 下午 7:00'
    }
  },
  {
    id: 'hongkong',
    name: 'Hong Kong',
    region: 'asia',
    lat: 22.4439,
    lng: 114.0302,
    address: '新界元朗流浮山厦村屏厦路DD129，3221地段',
    phone: '852-39071675',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm | Sat: 9:00 am – 4:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm | Sáb: 9:00 am – 4:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm | Sáb: 9:00 am – 4:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00 | 周六:上午 9:00 – 下午 4:00'
    }
  },
  {
    id: 'dubai',
    name: 'Dubai',
    region: 'asia',
    lat: 25.2048,
    lng: 55.2708,
    address: 'Dubai, United Arab Emirates',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00'
    }
  },
  // Africa
  {
    id: 'ethiopia',
    name: 'Ethiopia',
    region: 'africa',
    lat: 8.9806,
    lng: 38.7578,
    address: 'Addis Ababa, Ethiopia',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00'
    }
  },
  // South America
  {
    id: 'saopaulo',
    name: 'São Paulo',
    region: 'southamerica',
    lat: -23.5505,
    lng: -46.6333,
    address: 'São Paulo, Brasil',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00'
    }
  },
  // Europe
  {
    id: 'madrid',
    name: 'Madrid',
    region: 'europe',
    lat: 40.4697,
    lng: -3.5756,
    address: 'Avda. Central, 13 28042, Madrid',
    hours: {
      en: 'Mon-Fri: 8:00 am – 6:00 pm',
      es: 'Lun-Vie: 8:00 am – 6:00 pm',
      pt: 'Seg-Sex: 8:00 am – 6:00 pm',
      zh: '周一至周五:上午 8:00 – 下午 6:00'
    }
  },
  {
    id: 'london',
    name: 'London',
    region: 'europe',
    lat: 51.4340,
    lng: -0.4526,
    address: 'Unit 4, Ashford Industrial Estate, Shield Road, Ashford, Middlesex, TW15 1AU',
    hours: {
      en: 'Mon-Fri: 9:00 am – 6:00 pm',
      es: 'Lun-Vie: 9:00 am – 6:00 pm',
      pt: 'Seg-Sex: 9:00 am – 6:00 pm',
      zh: '周一至周五:上午 9:00 – 下午 6:00'
    }
  }
];
